import { url } from "@vuelidate/validators";

export const faqs = [
{
  title: 'General',
  faqs: [
    { title: 'I’ve never rented LEGO® before, what if I don’t like it?', url: 'can-i-get-my-money-back-if-i-dont-like-it' },
    { title: 'I really want to build big LEGO® sets!', url: 'can-i-rent-high-value-lego-sets-from-day-one' },
    { title: 'Are your LEGO® bricks genuine?', url: 'are-your-lego-bricks-genuine' },
    { title: 'How do you keep the LEGO® sets clean?', url: 'how-do-you-keep-the-lego-sets-clean' },
    // { title: 'What is the refundable security deposit?', url: 'what-is-the-refundable-security-deposit' },
    { title: 'It doesn’t look like you have a set I’m looking for, can I request it?', url: 'can-i-request-a-set-thats-not-in-your-library' },
    { title: 'I have some LEGO® sets I no longer want, will you buy them off me?', url: 'will-you-buy-my-unwanted-lego-sets-off-me' },
    { title: 'Can I pause my subscription?', url: 'can-i-pause-my-subscription' },
    // { title: 'How do I return a set?', url: 'how-do-i-return-a-set' },
    // { title: 'What is the Apprentice Period?', url: 'what-is-the-apprentice-period' },
    // How do I return a set?
    // Can I reserve a set?
    // How many sets can I reserve?
    // How can I get in touch with someone?
    // My package hasn’t arrived.
    // Do I have to dismantle sets before sending them back?
    // How are the sets organised into bags?
    // I'm missing a piece!  // Check the next bags!
    // I don't have any instructions in the box
    // I think I've lost a piece, what do I do?
    // What's the age range?
    // How long can I borrow sets for?
    // Is the LEGO official?
    // How do I know if a set is available?
    // How do I rent a set?
    // How do I reserve a set?
    // Where do you deliver to? UK, (everywhere under standard Royal Mail shipping)
    // Can I purchase the set if I want to keep it?
    // Do you buy LEGO?
    // Which is better, subscription or pay-as-you-go?
    // { title: 'Can I send you photos?', url: 'can-i-send-you-photos' },
    // Can I tag you on social media?
    // Are you on social media?
    // Where are your terms & conditions?
    // How much does it cost?
    // How do the sets come? In one bag, or multiple?
    // A piece is dirty, what do I do?
    // I don't have any instructions in the box, what do I do?
    // I spilt something on the set, what do I do?
    // How long does it take to get my security deposit back?
    // Can I reserve a set for a particular date?
    // Why would I rent LEGO?
    // Why is renting better than buying second-hand?
    // How do I change my shipping address?
    // How can I update my payment method?
    // Can I refer a friend?
    // Do you offer any discounts? // Refer £5, photo £2.50, follow all socials £1
    // What is the Compulsory Security Deposit?
    // How long can I expect to wait for a set? // We have indicators on each set. Could we also calculate an average queue length across all sets? 
    




    // What happens if someone reserves a set on PAYG, waits for their turn, then signs up
    // to a subscription to get it "cheaper" than if they paid the PAYG pricing? Are there
    // two states you can be in for reserving? So you could subscribe, but when you turn
    // comes around you'll need to pay the PAYG pricing extra? This feels complicated.
    // A similar issue, what happens if someone reserves while on a subscription, then cancels.
    // We've said their reservations will be lost, but should they or should they turn into
    // PAYG reservations? The money is less of an issue here as they are likely to pay us
    // more, so it's only if we want to threaten the loss of their reservation to get them to
    // get theym to stay on subscription.
  ],
},
{
  title: 'Subscriptions',
  faqs: [
    { title: 'What is the Apprentice Period at the start of a subscription?', url: 'what-is-the-apprentice-period-at-the-start-of-a-subscription' },
    { title: 'Can I choose my subscription start date?', url: 'can-i-choose-my-subscription-start-date' },
    // { title: 'Is postage & packaging included in my subscription?', url: 'what-are-the-delivery-and-return-charges' },
    { title: 'Can I pause my subscription?', url: 'can-i-pause-my-subscription' },
    { title: 'I have a subscription, when can I get my security deposit back?', url: 'i-have-a-subscription-when-can-i-get-my-security-deposit-back' },
    { title: 'How do I cancel my subscription?', url: 'how-do-i-cancel-my-subscription' },
    // Can I still enjoy the other perks of my chosen subscription plan from day 1 during the Apprentice Period?
    // Can I skip the Apprentice Period?
    // What happens with my secruity deposit?
    // I need to change my card details
    // I need to change my address
    // Can I reserve a set on a higher tier than my current plan?
    // What happens to my reservations if I downgrade?
    // Can I change plan?
    // My package is taking a longer than expected to arrive
    // How long does it take to check over a set before my next one is sent out?
    // If I join the Master plan, can I reserve my 2 sets separately or do they need to be ordered together?
  ]
},
{
  title: 'Pay-As-You-Go (PAYG)',
  faqs: [
    { title: 'Do you offer one-off rentals?', url: 'do-you-offer-one-off-rentals' },
    { title: 'I rented a set on PAYG, when can I get my security deposit back?', url: 'i-rented-a-set-on-payg-when-can-i-get-my-security-deposit-back' },
    // What are PAYG rentals?
    // When does my weekly billing cycle begin?
    // My package is taking a longer than expected to arrive
  ]
},
{
  title: 'Building',
  faqs: [
    { title: 'Are paper copies of the instruction booklets included?', url: 'are-paper-copies-of-the-instruction-booklets-included' },
    { title: 'What is the official ‘LEGO® Builder’ app?', url: 'what-is-the-official-lego-builder-app', lastReviewed: '2025-05-06' },
    { title: 'Where can I find PDF copies of the instruction booklets?', url: 'where-can-i-find-pdf-copies-of-the-instruction-booklets' },
    // How best to sort pieces when they arrive?
    // When can I access PDF instructions?
  ]
},
{
  title: 'Shipping & Returns',
  faqs: [
    { title: 'What are the delivery and return charges?', url: 'what-are-the-delivery-and-return-charges' },
    // How are packages shipped?
    // How do I get my returns label?
    // Do I need to be in to receive my package? Yes
    // I'm not in to receive my package, what do I do? Reschedule
    // My package is taking a longer than expected to arrive
    { title: 'I’ve finished with my set, what now?', url: 'ive-finished-with-my-set-what-now' },
    { title: 'What is the Dismantling Service?', url: 'what-is-the-dismantling-service' },
    // How long does the shipping label last for?
    { title: 'How can I return my package using Royal Mail?', url: 'how-can-i-return-my-package-using-royal-mail', lastReviewed: '2025-05-05' },
    { title: 'Is the pre-paid return label inside the box?', url: 'is-the-pre-paid-return-slip-inside-the-box' },
    { title: 'Do I need a printer to print the pre-paid return label?', url: 'do-i-need-a-printer-to-print-the-pre-paid-return-label' },
    { title: 'Royal Mail is asking for a tracking number, where do I find this?', url: 'royal-mail-is-asking-for-a-tracking-number-where-do-i-find-this' },
    // Do I need to pay for return shipping?
    // { title: 'How should I prepare my return package?', url: 'how-should-i-prepare-my-return-package' },
    // { title: 'What is the dismantling service?', url: 'what-is-the-dismantling-service' },
    // Do I need to dismantle the set before I return it?
    // What is the dismantling service?
    // I can’t get some pieces apart, what should I do?
    // Are there are pieces that I shouldn’t take apart?
    // I dismantled everything back into it's bags and then I found a piece, what do I do? If obvious, put it in the right bag, otherwise put it in bag 1.
  ]
},
{
  title: 'FAQs', 
  faqs: [
    { title: 'I’ve never rented LEGO® before, what if I don’t like it?', url: 'can-i-get-my-money-back-if-i-dont-like-it' },
    { title: 'I really want to build big LEGO® sets!', url: 'can-i-rent-high-value-lego-sets-from-day-one' },
    { title: 'Are your LEGO® bricks genuine?', url: 'are-your-lego-bricks-genuine' },
    { title: 'How do you keep the LEGO® sets clean?', url: 'how-do-you-keep-the-lego-sets-clean' },
    // { title: 'Do I need to take apart the set before returning it?', url: 'do-i-need-to-take-apart-the-set-before-returning-it' },
    { title: 'What are the delivery and return charges?', url: 'what-are-the-delivery-and-return-charges' },
    { title: 'My set didn’t come with instructions, what should I do?', url: 'are-paper-copies-of-the-instruction-booklets-included' },
    { title: 'I’m ready to return my set', url: 'ive-finished-with-my-set-what-now' },
  ],
},
]